import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { MyOffersLobbyComponent } from "@obg/ngx.ui.common";

@Injectable({
	providedIn: "root",
})
export class MyOffersGuard implements CanDeactivate<MyOffersLobbyComponent> {
	canDeactivate(component: MyOffersLobbyComponent): boolean {
		return component.canDeactivate ? component.canDeactivate() : true;
	}
}
